var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-searchable',{attrs:{"currentValue":_vm.currentValue,"keyword":_vm.keyword,"list":_vm.unitsList},on:{"toggle":function($event){return _vm.$emit('toggle', $event)},"input":_vm.search,"select":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }